import { useSyncExternalStore } from 'react';

/**
 * Whether this browser has opened Slideshows yet, for the sidebar "New" tag (same as Stories' lib/seen.ts).
 * localStorage can be blocked; on failure the tag keeps showing.
 */
export const SLIDESHOWS_SEEN_KEY = 'og-slideshows-seen';
const EVENT = 'og-slideshows-seen';

function read(): boolean {
  try {
    return window.localStorage.getItem(SLIDESHOWS_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSlideshowsSeen(): void {
  try {
    if (window.localStorage.getItem(SLIDESHOWS_SEEN_KEY) === '1') return;
    window.localStorage.setItem(SLIDESHOWS_SEEN_KEY, '1');
  } catch {
    return;
  }
  window.dispatchEvent(new Event(EVENT));
}

function subscribe(onChange: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === SLIDESHOWS_SEEN_KEY) onChange();
  };
  window.addEventListener(EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
}

export function useSlideshowsSeen(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
